module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#play",
      toString: function () {
        return this.url;
      }
    }